import { useCallback, useMemo } from 'react';

import { Alerts } from '@components';
import { useBaseStore } from '@store';

export interface AlertHook {
	hide: () => void;
	show: () => void;
	isVisible: boolean;
}

export const useAlert = (alertName: Alerts): AlertHook => {
	const hideAlert = useBaseStore((state) => state.hideAlert);
	const showAlert = useBaseStore((state) => state.showAlert);
	const visibleAlert = useBaseStore((state) => state.visibleAlert);

	const show = useCallback(() => {
		showAlert(alertName);
	}, [alertName, showAlert]);

	const hide = useCallback(() => {
		hideAlert(alertName);
	}, [alertName, hideAlert]);

	const isVisible = useMemo(() => {
		return visibleAlert === alertName;
	}, [alertName, visibleAlert]);

	return {
		hide,
		show,
		isVisible,
	};
};
